export default function Header() {
    return (
        <div>
            <h1>chirpspace</h1>
            <h3>write tweets distraction-free</h3>
        </div>
    );
}